import React, { useLayoutEffect } from 'react';

type PropsType = {
  production?: boolean;
};

export const PaylineHead: React.ComponentType<PropsType> = ({
  production = false,
}) => {
  const baseUrl = production
    ? 'https://payment.cdn.payline.com/cdn'
    : 'https://homologation-payment.cdn.payline.com/cdn';

  return (
    <>
      <script src={`${baseUrl}/scripts/widget-min.js`} />
      <link href={`${baseUrl}/styles/widget-min.css`} rel="stylesheet" />
    </>
  );
};

const PaylineProvider: React.FunctionComponent<
  React.PropsWithChildren<PropsType>
> = ({ production = false, children }) => {
  const baseUrl = production
    ? 'https://payment.cdn.payline.com/cdn'
    : 'https://homologation-payment.cdn.payline.com/cdn';

  const scriptUrl = `${baseUrl}/scripts/widget-min.js`;

  useLayoutEffect(() => {
    let script: HTMLScriptElement | null = document.querySelector(
      `script[src="${scriptUrl}"]`,
    );

    if (!script) {
      script = document.createElement('script');
      script.src = scriptUrl;
      document.head.appendChild(script);
    }
  }, [scriptUrl]);

  const stylesheetUrl = `${baseUrl}/styles/widget-min.css`;

  useLayoutEffect(() => {
    let stylesheet: HTMLLinkElement | null = document.querySelector(
      `link[href="${stylesheetUrl}"]`,
    );

    if (!stylesheet) {
      stylesheet = document.createElement('link');
      stylesheet.href = stylesheetUrl;
      stylesheet.rel = 'stylesheet';
      document.head.appendChild(stylesheet);
    }
  }, [stylesheetUrl]);

  return children;
};

export default PaylineProvider;
